import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, switchMap} from 'rxjs/operators';
// tslint:disable-next-line:import-blacklist
import {BehaviorSubject, Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {from} from 'rxjs/observable/from';
import {BASE_URL_CERT_GEN, BASE_URL_SCAB, URL_PROXY_BC} from '../util/constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  refreshTokenInProgress = false;
  tokenRefreshed = new BehaviorSubject(null);

  constructor(
    private authService: AuthService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const request = this.addAuthHeader(req);
    return next.handle(request)
      .pipe(
        catchError((err) => {
          console.log('err', err);
          if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
            this.generateTokenBarramento().subscribe();

            return from(this.generateTokenSCAB()
              .pipe(switchMap(() => next.handle(this.addAuthHeader(request)))));
          }

          throw err;
        }));
  }

  private addAuthHeader(request) {
    const url = request.url;
    console.log('url', url);
    // if (production) {
    const tokenScab = this.authService.getLocalTokenScab();
    const tokenBc = this.authService.getLocalTokenBrasilCidadao();
    const tokenBarramento = this.authService.getLocalTokenBarramento();

    if ((url.indexOf(BASE_URL_SCAB) > -1 && url.indexOf('login') === -1 && url.indexOf(URL_PROXY_BC) === -1)) {
      return request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: tokenScab,
          AuthorizationSerpro: tokenBc,
        }
      });
    }
    // console.log('tokenBarramento',  tokenBarramento)
    // console.log('url.indexOf(BASE_URL_CERT_GEN)',  url.indexOf(BASE_URL_CERT_GEN))
    if (url.indexOf(BASE_URL_CERT_GEN) > -1) {
      return request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Authorization: tokenBarramento,
          //AuthorizationSerpro: tokenBc,
        }
      });
    }
    // } else {
    //   const tokenBarramento = this.authService.getLocalTokenBarramento();
    //   if (url.indexOf(BASE_URL_CERT_GEN) > -1) {
    //     return request.clone({
    //       setHeaders: {
    //         'Content-Type': 'application/json',
    //         Authorization: tokenBarramento,
    //         //AuthorizationSerpro: tokenBc,
    //       }
    //     });
    //   }
    // }

    return request;
  }

  private generateTokenSCAB() {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;

      return new Observable(observer => {
        return from(this.authService.loginScab()).subscribe(observer);
      });
    }
  }

  private generateTokenBarramento() {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;

      return new Observable(observer => {
        return from(this.authService.loginBarramento()).subscribe(observer);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/interceptors/auth.interceptor.ts